import {type WarehouseRequestType} from "./WarehouseApi";


export const defaultWarehouse: WarehouseRequestType = {
    name: '',
    geom: {
        type: 'Point',
        coordinates: [0, 0]
    },
    details: {
        street: '',
        city: '',
        house:'',
        query: '',
        abbreviation: '',
    },
}